import { render } from "./AnswerImageColumn.vue?vue&type=template&id=9e523c08&scoped=true"
import script from "./AnswerImageColumn.vue?vue&type=script&lang=ts"
export * from "./AnswerImageColumn.vue?vue&type=script&lang=ts"

import "./AnswerImageColumn.vue?vue&type=style&index=0&id=9e523c08&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9e523c08"

export default script